import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import useCcWebviewUtilsHelper from '@di-shared/features/common/useCcWebviewUtilsHelper';
import Header from '@di-shared/features/common/Header';
import HeaderCloseButton from '@di-shared/features/common/HeaderCloseButton';
import React from 'react';
import useApiError from '@di-shared/features/common/useApiError';
import {GlobalErrorBoundaryProps} from '@di-shared/features/common/GlobalErrorBoundary/index';
import {InteractionLottie} from '@di-shared/features/about/About';

export default function ({error}: GlobalErrorBoundaryProps) {
  const {t} = useInferableTranslation();
  const {backOrClose} = useCcWebviewUtilsHelper();
  const {getErrorCode} = useApiError();

  return (
    <div className="wrap">
      <Header right={<HeaderCloseButton />} />

      <main className="content page_error">
        <div className="empty_section">
          {(import.meta.env.VITE_PROFILE === 'dev' || import.meta.env.VITE_PROFILE === 'local') && (
            <p className="body_small_r empty_section_text">{(error as any)?.statusText || (error as any)?.message}</p>
          )}
          <div className="loading_lottie loading_lottie_motion">
            <InteractionLottie
              kiaLightSrc={() => import('@di-shared/assets/img/json/block_motion_light.json')}
              kiaDarkSrc={() => import('@di-shared/assets/img/json/block_motion.json')}
              hyundaiLightSrc={() => import('@di-shared/assets/img/json/block_motion_light.json')}
              hyundaiDarkSrc={() => import('@di-shared/assets/img/json/block_motion.json')}
              genesisLightSrc={() => import('@di-shared/assets/img/json/block_motion_light.json')}
              genesisDarkSrc={() => import('@di-shared/assets/img/json/block_motion.json')}
              loop={false}
              autoplay={false}
            />
          </div>
          <h2 className="title_xsmall_b empty_section_title">{t('msg_error_title')}</h2>
          <p
            className="empty_section_text"
            style={{whiteSpace: 'pre-wrap'}}
          >
            {t('msg_error_title_01')}
          </p>
          <p
            className="empty_section_text"
            style={{whiteSpace: 'pre-wrap'}}
          >
            {t('msg_error_title_02')}
          </p>
          <p
            className="body_small_r empty_section_text"
            style={{whiteSpace: 'pre-wrap'}}
          >
            {t('msg_error_code_$nnnn', {nnnn: getErrorCode(error)})}
          </p>
          <button
            type="button"
            className="btn btn_filled_tonal"
            onClick={() => backOrClose()}
          >
            {t('imsi_backwards')}
          </button>
        </div>
      </main>
    </div>
  );
}
